import React from 'react';
import { useTimezone } from '../../hooks/useTimezone';
import { useTranslation } from 'react-i18next';
import './TimezoneSelector.css';

export function TimezoneSelector() {
  const { timezone, setTimezone, supportedTimezones } = useTimezone();
  const { t } = useTranslation();
  
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setTimezone(e.target.value);
  };

  return (
    <div className="timezone-selector">
      <select
        value={timezone}
        onChange={handleChange}
        className="timezone-selector__select"
        aria-label={t('pages.configuration.timezoneLabel')}
      >
        {supportedTimezones.map((tz) => (
          <option key={tz} value={tz}>
            {tz}
          </option>
        ))}
      </select>
    </div>
  );
}
